module.exports = __webpack_public_path__ + "img/auditorium.ac5b1bda.svg";